<template>
  <van-popup v-model="filterShow" class="right-filter-info" position="right" :style="{ height: '100vh', width: '85%' }">
    <div class="title">Filter</div>
    <div class="collapse-content-info" @touchmove.stop>
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item :title="$t('shared.title.basicInfo')" name="1">
          <template #title>
            <div class="collapse-title">{{ $t('shared.title.basicInfo') }}. <span :class="{'collapse-checked': bascInfoChecked}"></span></div>
          </template>
          <div class="form-field">
            <div class="field-label">{{ $t('shared.title.storeTag') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': filterData.customerTag === subItem.value}" v-for="(subItem, subIndex) in storeTagTypeList" :key="subIndex" @click="handleCheck(subItem, 'customerTag')">{{ subItem.label }}</div>
            </div>
          </div>
          <div class="form-field">
            <div class="field-label">{{ $t('shared.title.productListed') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': isProject === ''}" @click="handleCheck('', 'isProject')">{{ $t('shared.filter.noFilter') }}</div>
              <div class="radio-name" :class="{'value-check': isProject === 'Filter'}" @click="handleCheck('Filter', 'isProject')">{{ $t('shared.titleOne') }}</div>
            </div>
            <div class="select-info" v-show="isProject === 'Filter'">
              <van-dropdown-menu active-color="#307bff">
                <van-dropdown-item v-model="filterData.shelfOperate" :options="specialProjectOperateList" />
              </van-dropdown-menu>
              <van-checkbox-group class="checkbox-custom" v-model="filterData.shelfProductIdList">
                <van-checkbox shape="square" v-for="(subItem, subIndex) in globalData.productList" :key="subIndex" :name="subItem.id">{{ subItem.productName }}</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
          <div class="form-field">
            <div class="field-label">{{ $t('shared.title.incentive') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': filterData.incentiveType === subItem.value}" v-for="(subItem, subIndex) in incentiveTypeList" :key="subIndex" @click="handleCheck(subItem, 'incentiveType')">{{ subItem.label }}</div>
            </div>
          </div>
          <div class="form-field">
            <!-- 是否举办过Pop up Event -->
            <div class="field-label">{{ $t('shared.title.eventHeld') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': filterData.isPopUpEvent === subItem.value}" v-for="(subItem, subIndex) in isPopUpEventList" :key="subIndex" @click="handleCheck(subItem, 'isPopUpEvent')">{{ subItem.label }}</div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.title.storeAssignment')" v-if="mapType != '1'" name="2">
          <template #title>
            <div class="collapse-title">{{ $t('shared.title.storeAssignment') }} <span :class="{'collapse-checked': storeBelongChecked}"></span></div>
          </template>
          <div class="form-field">
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': storeBelongToVal === ''}" @click="handleCheck('', 'storeBelongToVal')">{{ $t('shared.filter.noFilter') }}</div>
              <div class="radio-name" :class="{'value-check': storeBelongToVal === 'Department'}" @click="handleCheck('Department', 'storeBelongToVal')">{{ $t('shared.title.filterDepartment') }}</div>
            </div>
            <div class="select-info" v-if="storeBelongToVal === 'Department'">
              <XuCascader v-model="filterData.deptIdList" :deptOption="deptOption" />
            </div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': storeBelongToVal === 'Person'}" @click="handleCheck('Person', 'storeBelongToVal')">{{ $t('shared.title.filterPerson') }}</div>
            </div>
            <van-checkbox-group v-show="storeBelongToVal === 'Person'" v-model="filterData.personVal" @change="handleCheck('Person', 'personVal')">
              <van-checkbox shape="square" v-for="(subItem, subIndex) in storePerSonList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-checkbox>
            </van-checkbox-group>
            <XuSelect v-if="filterData.personVal.includes('customize')" v-model="filterData.userIdList" :dataOptions="globalData.userOptions" :multiple="true" :fieldNames="{label: 'nickName', value: 'id'}" />
          </div>
        </van-collapse-item>
         <!-- v-if="pageType === 'storeMaintain'" -->
        <van-collapse-item :title="$t('shared.title.storeVisit')" name="3">
          <template #title>
            <div class="collapse-title">{{ $t('shared.title.storeVisit') }} <span :class="{'collapse-checked': storeVisitChecked}"></span></div>
          </template>
          <div class="form-field">
            <div class="field-label">{{ $t('shared.title.visitOrNot') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': filterData.isVisit === subItem.value}" v-for="(subItem, subIndex) in isPopUpEventList" :key="subIndex" @click="handleCheck(subItem, 'isVisit')">{{ subItem.label }}</div>
            </div>
          </div>
          <div class="form-field" v-if="filterData.isVisit !== '0'">
            <div class="field-label">{{ $t('shared.title.timeSinceLastVisit') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': filterData.visitDay === subItem.value}" v-for="(subItem, subIndex) in timeSinceLastList" :key="subIndex" @click="handleCheck(subItem, 'visitDay')">{{ subItem.label }}</div>
            </div>
            <van-row v-if="filterData.visitDay === 'customizable'" class="row-content">
              <van-col span="9">
                <van-field type="digit" class="field-input" v-model="filterData.visitStartDay" label="" placeholder="" @input="(val) => handleInput(val, 'visitStartDay')" />
              </van-col>
              <van-col span="2" style="text-align: center">-</van-col>
              <van-col span="9">
                <van-field type="digit" class="field-input" v-model="filterData.visitEndDay" label="" placeholder="" @input="(val) => handleInput(val, 'visitEndDay')" />
              </van-col>
              <van-col span="4" style="padding-left: 3px;">{{ $t('shared.title.days') }}</van-col>
            </van-row>
          </div>
          <div class="form-field">
            <div class="field-label">{{ $t('shared.title.reOrderOrNot') }}</div>
            <div class="field-value">
              <div class="radio-name" :class="{'value-check': isVisitProject === ''}" @click="handleCheck('', 'isVisitProject')">{{ $t('shared.filter.noFilter') }}</div>
              <div class="radio-name" :class="{'value-check': isVisitProject === 'Filter'}" @click="handleCheck('Filter', 'isVisitProject')">{{ $t('shared.titleOne') }}</div>
            </div>
            <div class="select-info" v-if="isVisitProject === 'Filter'">
              <van-dropdown-menu active-color="#007bff">
                <van-dropdown-item v-model="filterData.reorderOperate" :options="visitProjectList" />
              </van-dropdown-menu>
              <van-checkbox-group class="checkbox-custom" v-model="filterData.reorderProductIdList">
                <van-checkbox shape="square" v-for="(subItem, subIndex) in globalData.productList" :key="subIndex" :name="subItem.id">{{ subItem.productName }}</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
          <div class="form-field">
            <div class="field-label">{{ $t('shared.title.visitByBa') }}</div>
            <div class="field-value">
              <van-checkbox-group v-model="filterData.visitByBaVal" style="margin-top: 5px;">
                <van-checkbox shape="square" v-for="(subItem, subIndex) in personList" :key="subIndex" :name="subItem.value" @click="handleCheck('', 'visitByBaVal')">{{ subItem.label }}</van-checkbox>
              </van-checkbox-group>
              <XuSelect v-if="filterData.visitByBaVal.includes('customize')" v-model="filterData.visitUserIdList" :dataOptions="globalData.userOptions" :multiple="true" :fieldNames="{label: 'nickName', value: 'id'}" />
              <van-checkbox style="margin-top: 5px;" v-if="filterData.visitByBaVal.includes('Me') || filterData.visitByBaVal.includes('customize')" v-model="filterData.isLastVisit" shape="square">{{ $t('shared.titleTwo') }}</van-checkbox>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="filter-btn">
      <div class="reset-btn" @click="handleReset">{{ $t('button.reset') }}</div>
      <div class="confirm-btn" @click="handleConfirmFilter">{{ $t('shared.filter.viewStore') }}</div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
import XuCascader from '@/components/XuCascader'
import XuSelect from '@/components/XuSelect'
const newFilterData = {
  customerTag: '',
  shelfOperate: '',
  shelfProductIdList: [],
  deptIdList: [],
  userIdList: [],
  personVal: [],
  incentiveType: '',
  isPopUpEvent: '',
  isVisit: '',
  visitDay: '',
  visitStartDay: '',
  visitEndDay: '',
  reorderProductIdList: [],
  reorderOperate: '1',
  visitByBaVal: [''],
  visitUserIdList: [],
  isLastVisit: false
}
export default {
  props: {
    deptOption: {
      type: Array,
      default: () => []
    },
    mapType: {
      type: String,
      default: ''
    }
  },
  components: {
    XuCascader,
    XuSelect
  },
  data () {
    return {
      filterShow: false,
      activeNames: '1',
      filterData: {
        customerTag: '',
        shelfOperate: '',
        shelfProductIdList: [],
        deptIdList: [],
        userIdList: [],
        personVal: [],
        incentiveType: '',
        isPopUpEvent: '',
        isVisit: '',
        visitDay: '',
        visitStartDay: '',
        visitEndDay: '',
        reorderProductIdList: [],
        reorderOperate: '1',
        visitByBaVal: [''],
        visitUserIdList: [],
        isLastVisit: false
      },
      isProject: '',
      storeBelongToVal: '',
      isVisitProject: '',
      specialProjectOperateList: [
        { text: this.$t('shared.filter.containAny'), value: '0' },
        { text: this.$t('shared.filter.notContainAny'), value: '1' },
        { text: this.$t('shared.filter.notEqualTo'), value: '3' }
      ],
      storePerSonList: [
        { label: this.$t('shared.filter.me'), value: 'Me' },
        { label: this.$t('shared.filter.customize'), value: 'customize' }
      ],
      timeSinceLastList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.lessThanDays'), value: '0@6' },
        { label: this.$t('shared.filter.timeDays'), value: '7@15' },
        { label: this.$t('shared.filter.customize'), value: 'customizable' }
      ],
      personList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.me'), value: 'Me' },
        { label: this.$t('shared.filter.customize'), value: 'customize' }
      ],
      visitProjectList: [
        { text: this.$t('shared.filter.containAny'), value: '1' },
        { text: this.$t('shared.filter.containAll'), value: '0' }
      ],
      storeTagTypeList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.sVIPCore'), value: 1 },
        { label: this.$t('shared.filter.vIPCore'), value: 2 },
        { label: this.$t('shared.filter.potential'), value: 3 },
        { label: this.$t('shared.filter.toBeVerified'), value: '0' }
      ],
      incentiveTypeList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.activated'), value: 1 }, // 已开通
        { label: this.$t('shared.filter.participated'), value: 2 }, // 已参加
        { label: this.$t('shared.filter.notParticipated'), value: 3 }, // 未参加
        { label: this.$t('shared.filter.notActivated'), value: 4 } // 未开通
      ],
      isPopUpEventList: [
        { label: this.$t('shared.filter.noFilter'), value: '' },
        { label: this.$t('shared.filter.yes'), value: '1' },
        { label: this.$t('shared.filter.no'), value: '0' }
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    bascInfoChecked () {
      const {
        customerTag = '',
        shelfProductIdList = [],
        shelfOperate = '',
        incentiveType = '',
        isPopUpEvent = ''
      } = this.filterData
      return (
        customerTag !== '' ||
        shelfProductIdList.length > 0 ||
        shelfOperate !== '' ||
        incentiveType !== '' ||
        isPopUpEvent !== ''
      )
    },
    storeBelongChecked () {
      const {
        deptIdList = [],
        personVal = [],
        userIdList = []
      } = this.filterData
      return (
        deptIdList.length > 0 || personVal.length > 0 || userIdList.length > 0
      )
    },
    storeVisitChecked () {
      const { reorderProductIdList = [], reorderOperate = '1', isVisit = '', visitDay = '', visitStartDay = '', visitEndDay = '', visitUserIdList = [], isLastVisit = false, visitByBaVal = [''] } = this.filterData
      return (
        reorderProductIdList.length > 0 ||
        reorderOperate !== '1' ||
        isVisit !== '' ||
        visitDay !== '' ||
        visitStartDay !== '' ||
        visitEndDay !== '' ||
        visitUserIdList.length > 0 ||
        isLastVisit ||
        visitByBaVal.some(item => item !== '')
      )
    }
  },
  methods: {
    setDefaultVal (data) {
      if (data) {
        this.filterData = data
      }
    },
    // 单选
    handleCheck (params, type) {
      if (['isProject'].includes(type)) {
        this[type] = params
        this.filterData.specialProjectOperate = '0'
        this.filterData.specialProjectList = []
      } else if (['storeBelongToVal'].includes(type)) {
        this[type] = params
        this.filterData.personVal = []
        this.filterData.userIdList = []
        this.filterData.deptIdList = []
      } else if (['personVal'].includes(type)) {
        if (!this.filterData.personVal.includes('customize')) {
          this.filterData.userIdList = []
        }
      } else if (['isVisitProject'].includes(type)) {
        this[type] = params
        this.filterData.reorderOperate = '1'
        this.filterData.reorderProductIdList = []
      } else if (['visitDay'].includes(type)) {
        this.filterData[type] = params.value
        this.filterData.visitStartDay = ''
        this.filterData.visitEndDay = ''
      } else if (['visitByBaVal'].includes(type)) {
        const newVisitByBaVal = JSON.parse(JSON.stringify(this.filterData.visitByBaVal))
        if (newVisitByBaVal[newVisitByBaVal.length - 1] === '' || newVisitByBaVal.length === 0) {
          this.filterData[type] = ['']
          this.filterData.isLastVisit = false
          this.filterData.visitUserIdList = []
        } else {
          this.filterData[type] = this.filterData[type].filter(subItem => subItem !== '')
        }
        if (!newVisitByBaVal.includes('customize')) {
          this.filterData.visitUserIdList = []
        }
      } else {
        // type 'isChain' customerClass
        this.filterData[type] = params.value
      }
    },
    handleInput (val, type) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.timer = null
        // 只能输入正整数
        if (['visitStartDay', 'visitEndDay'].includes(type)) {
          this.filterData[type] = val.replace(/[^\d]/g, '').replace(/^0+([1-9])/g, '$1')
          if (['visitEndDay'].includes(type) && this.filterData[type]) {
            this.filterData[type] = Number(this.filterData[type]) < Number(this.filterData.visitStartDay) ? '' : this.filterData[type]
          }
        }
      }, 500)
    },
    handleReset () {
      this.isProject = ''
      this.storeBelongToVal = ''
      this.isVisitProject = ''
      this.filterData = JSON.parse(JSON.stringify(newFilterData))
      this.handleConfirmFilter()
    },
    handleConfirmFilter () {
      this.$emit('changeFilter', this.filterData)
      this.filterShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.right-filter-info {
  font-size: 12px;
  overflow: hidden;
  .title {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }
  .collapse-title {
    display: flex;
    align-items: center;
    font-weight: bold;
  }
  .form-field {
    color: #000;
    font-size: 12px;
    margin-bottom: 5px;
    .field-label {
      margin-bottom: 5px;
      font-weight: bold;
    }
    .field-value {
      display: flex;
      flex-wrap: wrap;
      font-size: 12px;
      box-sizing: border-box;
      .radio-name {
        padding: 3px 8px;
        margin-right: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
        background-color: #e8effc;
        border: 1px solid #fff;
      }
    }
    .value-check {
      color: #307bff;
      border: 1px solid #307bff !important;
    }
    .select-info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    /deep/.van-checkbox-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .van-checkbox {
        margin-right: 5px;
        margin-bottom: 5px;
        .van-checkbox__label {
          margin-left: 3px;
        }
      }
    }
    .checkbox-custom {
      padding-top: 5px;
    }
    /deep/.van-dropdown-menu__title--active,
    /deep/.van-dropdown-item__option--active {
      color: #000;
    }
    /deep/.van-dropdown-menu {
      width: 120px;
      margin-right: 10px;
      .van-dropdown-menu__item {
        margin-right: 4px;
      }
      .van-dropdown-menu__title {
        font-size: 12px;
        padding: 0;
        padding-right: 8px;
      }
      .van-dropdown-menu__bar {
        height: 30px;
        border: 1px solid #dcdfe6;
      }
      .van-dropdown-menu__title::after {
        border-color: transparent transparent #000 #000;
      }
      .van-dropdown-item {
        z-index: 999;
      }
      .van-cell {
        font-size: 12px;
      }
    }
    .row-content {
      display: flex;
      align-items: center;
      font-size: 12px;
      .field-input {
        border: 1px solid #eee;
        padding: 5px 10px;
        font-size: 12px;
      }
    }
  }
  .filter-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 58px;
    padding: 0 10px;
    border-top: 1px solid #edebeb;
    background-color: #fff;
    z-index: 99;
    .reset-btn,
    .confirm-btn {
      width: 48%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border: 1px solid #000;
      border-radius: 10px;
    }
    .reset-btn {
      background: #fff;
    }
    .confirm-btn {
      border: none;
      color: #fff;
      background-color: #307bff;
    }
  }
  .collapse-checked {
    width: 10px;
    height: 10px;
    background-color: #307bff;
    border-radius: 50%;
    margin-left: 5px;
  }
  .collapse-content-info {
    /deep/.van-collapse {
      height: calc(100vh - 180px);
      overflow: auto;
      overflow-y: auto;
      // .van-collapse-item {
      // pointer-events: none;
      // }
    }
    /deep/.van-hairline--top-bottom::after {
      border: none;
    }
  }
}
</style>
